import {
    apiDownloadDocumentAsArrayBuffer,
    apiDownloadGroupDocumentAsArrayBuffer,
    apiGetListGroupDocumentInfo
} from './document_management_service'
import {DOCUMENT} from '@/config/config_api_backend'
import {DownloadType, PlagScoreType} from '@/constants/DoITConstant'
import stringInject from 'stringinject'
import http from '../plugins/http'
import {apiGetLatestGroupVersion, apiGetLatestVersion} from './document_version_service'
import {uncompressSnappy} from '@/helpers/SnappyHelper'
import _ from 'lodash'

let getLevelPlagiarism = (score, configDocumentScore) => {
    if (score >= configDocumentScore['m1Score']) {
        return PlagScoreType.HIGH
    } else if (score >= configDocumentScore['m2Score']) {
        return PlagScoreType.MEDIUM
    }
    return PlagScoreType.LOW

}

let apiGetSpellingResult = async (slug) => {
    const data_spelling = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.SPELL_RESULT_JSON)
    return uncompressSnappy(data_spelling)
}

let apiGetPlagiarismResult = async (slug) => {
    const data = await Promise.all([
        apiDownloadDocumentAsArrayBuffer(slug, DownloadType.SIMILARITY_DATA_JSON),
        apiDownloadDocumentAsArrayBuffer(slug, DownloadType.SIMILARITIES_JSON)
    ])
    let rawResponse = data[0]
    let similarities = data[1]
    rawResponse = uncompressSnappy(rawResponse)
    similarities = uncompressSnappy(similarities)
    let response = {
        groupList: {
            similarSentences: rawResponse.similarSentences,
            similarSources: rawResponse.similarSources,
            sentences: rawResponse.sentences.map(sentence => {
                let {
                    content,
                    endWordId,
                    ignoreReason,
                    ignored,
                    labelsList: labels,
                    pageId,
                    highlights,
                    sentenceId: id,
                    startWordId
                } = sentence
                return {content, endWordId, ignoreReason, ignored, labels, pageId, highlights, id, startWordId}
            }),
            similarities: similarities.similarities.map(similarity => {
                let {
                    similarityId,
                    sentenceId: sentencesId,
                    similarSentenceId,
                    score,
                    highlights,
                    similarSourceId,
                    length
                } = similarity
                return {similarityId, sentencesId, similarSentenceId, score, highlights, similarSourceId, length}
            })
        },
        totalLength: rawResponse.totalLength,
    }
    let gottenVersion = await apiGetCurrentVersion(slug)
    return [response, response.totalLength, gottenVersion]
}

let apiGetCurrentVersion = async (slug) => {
    let response = await apiGetLatestVersion(slug)

    return response
}

let apiGetCurrentGroupVersion = async (slug) => {
    let response = await apiGetLatestGroupVersion(slug)
    return response

}

let apiGetGroupPlagiarismResult = async (slug) => {
    let rawResponse = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.SIMILARITY_DATA_JSON)
    let similarities = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.SIMILARITIES_JSON)
    rawResponse = uncompressSnappy(rawResponse)
    similarities = uncompressSnappy(similarities)
    let response = {
        groupList: {
            similarSentences: rawResponse.similarSentences,
            similarSources: rawResponse.similarSources,
            sentences: rawResponse.sentences.map(sentence => {
                let {
                    content,
                    endWordId,
                    ignoreReason,
                    ignored,
                    labelsList: labels,
                    pageId,
                    sentenceId: id,
                    highlights,
                    startWordId
                } = sentence
                return {content, endWordId, ignoreReason, ignored, labels, pageId, id, highlights, startWordId}
            }),
            similarities: similarities.similarities.map(similarity => {
                let {
                    similarityId,
                    sentenceId: sentencesId,
                    similarSentenceId,
                    score,
                    highlights,
                    similarSourceId,
                    length
                } = similarity
                return {similarityId, sentencesId, similarSentenceId, score, highlights, similarSourceId, length}
            })
        },
        totalLength: rawResponse.totalLength,
    }
    console.log(response)
    let version = await apiGetCurrentGroupVersion(slug)

    return [response, response.totalLength, version]
}

let updateGroupDocumentInfo = async (data_plagiarism) => {
    let idSet = new Set([])
    data_plagiarism.forEach(data => {
        data.similarSourcesList.forEach(source => {
            idSet.add(source.documentId)
        })
    })
    const listDocumentIds = Array.from(idSet)

    let response = await apiGetListGroupDocumentInfo(listDocumentIds)
    let ret = data_plagiarism.map(page => {
        let addedSimilarSources = page.similarSourcesList.map(source => ({
            ...source,
            ...response.find(res => res.documentId === source.documentId)
        }))

        return ({
            ...page,
            titleSource: addedSimilarSources[0] ? addedSimilarSources[0].title : 'Unknown title',
            link: addedSimilarSources[0] ? addedSimilarSources[0].link : 'Unknown link',
            similarSourcesList: addedSimilarSources
        })
    })

    return ret
}

let apiGetImageResult = async (slug) => {
    let data_images = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.IMAGE_PATH)
    data_images = uncompressSnappy(data_images)
    for (let data_image of data_images) {
        data_image['url'] = `/pages/${data_image['url'].replace('.jpg', '')}.dat`
    }
    return data_images
}

let apiGetGroupImageResult = async (slug) => {
    let data_images = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.IMAGE_PATH)
    data_images = uncompressSnappy(data_images)
    for (let data_image of data_images) {
        data_image['url'] = `/pages/${data_image['url'].replace('.jpg', '')}.dat`
    }
    return data_images
}

let apiUpdatePlagiarismIgnoredByUser = async (slug, lstResultPlagIgnoredCurrent) => {
    try {
        let url = stringInject(DOCUMENT.POST_SIMILARITY_RESULTS_IGNORED_BY_USER, {'slug': slug})
        let response = await http.post(url, JSON.stringify(lstResultPlagIgnoredCurrent), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (e) {
        return null
    }
}


// New Service for new Result Viewer
let apiGetSimilarities = async (slug) => {
    const data = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.SIMILARITIES_JSON)
    return uncompressSnappy(data)
}

let apiGetGroupSimilarities = async (slug) => {
    const data = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.SIMILARITIES_JSON)
    return uncompressSnappy(data)
}

let apiGetSimilarityData = async (slug) => {
    const data = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.SIMILARITY_DATA_JSON)
    const uncompressedData = uncompressSnappy(data)
    uncompressedData.similarSources.forEach(data => {
        if (data.url && data.url.includes('123doc.org/')) {
            data.url = data.url.replace('123doc.org', '123docz.net')
        }
    })
    return uncompressedData
}
let apiGetGroupSimilarityData = async (slug) => {
    const data = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.SIMILARITY_DATA_JSON)
    let uncompressedData = uncompressSnappy(data)
    const documentIds = uncompressedData.similarSources.filter(s => s.domain === 'group').map(source => source.url)
    let groupDocumentInfo = await apiGetListGroupDocumentInfo(documentIds)
    groupDocumentInfo = _.keyBy(groupDocumentInfo, info => info.documentId)
    console.log(groupDocumentInfo)
    uncompressedData.similarSources.forEach(data => {
        const info = groupDocumentInfo[parseInt(data.url)]
        if (info) {
            data.url = info.link
            data.isGroup = true
            data.title = info.title
        }
    })
    return uncompressedData
}

export {
    apiGetGroupSimilarities,
    apiGetGroupSimilarityData,
    apiGetImageResult,
    apiGetPlagiarismResult,
    apiGetSpellingResult,
    apiUpdatePlagiarismIgnoredByUser,
    apiGetGroupImageResult,
    apiGetGroupPlagiarismResult,
    apiGetCurrentVersion,
    getLevelPlagiarism,
    apiGetSimilarities,
    apiGetSimilarityData,
    apiGetCurrentGroupVersion
}
